module.exports = __webpack_public_path__ + "static/media/12.ec9e7abe.jpg";